import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  Form,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Observable, Subject } from 'rxjs';
import { tap, takeUntil } from 'rxjs/operators';

// INTERFACES

// SERVICES
import { UnitClassApiService } from '../../../shared/services/api/unit-class-api.service';

// UTILS
import { trackById } from '../../../shared/util';
import { IUnitClass } from '../../../unit-of-measure/interfaces';

interface IData {
  lineItems :any[]; // TODO: create type
}

@Component({
  selector: 'lum-rfq-uom-form',
  templateUrl: './rfq-uom-form.component.html',
  styleUrls: ['./rfq-uom-form.component.scss'],
})
export class RfqUomFormComponent implements OnInit {
  form :UntypedFormGroup;
  unitClasses$ :Observable<IUnitClass[]>;
  unitClasses :IUnitClass[] = [];

  trackById = trackById;

  private onDestroy$ = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data :IData,
    private fb :UntypedFormBuilder,
    private dialogRef :MatDialogRef<RfqUomFormComponent>,
    private unitClassApiService :UnitClassApiService,
  ) {}

  ngOnInit() :void {
    this.unitClassApiService.get({ limit: '999' });
    this.getFromService();
    this.initForm();
    this.getUnitClasses().subscribe();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onSubmit() :void {
    this.dialogRef.close(this.form.value);
  }

  private getFromService() :void {
    this.unitClasses$ = this.unitClassApiService.unitClasses$;
  }

  private initForm() :void {
    this.form = this.fb.group({
      unitClassId: [null, Validators.required],
      uomId: [null, Validators.required],
    });
  }

  private getUnitClasses() :Observable<IUnitClass[]> {
    return this.unitClasses$.pipe(
      tap((unitClasses :IUnitClass[]) => {
        if (unitClasses?.length) {
          // Filter unitClasses by the ones that are in itemUnitClassIds
          this.unitClasses = unitClasses.filter((unitClass :IUnitClass) =>
            this.itemUnitClassIds.includes(unitClass.id),
          );
        }
      }),
      takeUntil(this.onDestroy$),
    );
  }

  get unitClassIdControl() :UntypedFormControl {
    return this.form.get('unitClassId') as UntypedFormControl;
  }

  get currentUnitClass() :IUnitClass | null {
    const unitClassId = this.unitClassIdControl.value;

    return (
      this.unitClasses.find(
        (unitClass :IUnitClass) => unitClass.id === unitClassId,
      ) || null
    );
  }

  get itemsWithSelectedClass() :any[] {
    return this.data.lineItems.filter(
      (lineItem :any) => lineItem.unit_class_id === this.unitClassIdControl.value,
    );
  }

  get itemUnitClassIds() :number[] {
    return this.data.lineItems.map((lineItem :any) => lineItem.unit_class_id);
  }
}
